<template>
  <div>
<div class="container">

<div class="row ap-frm-one" >
  <div class="col">

  <div class="row pt-5  " v-if="!edit">
    <div v-if="isLoadinglogo">
        <semipolar-spinner
                  :animation-duration="2000"
                  :size="80"
                  color="blue"></semipolar-spinner>
      </div>
    <div class="col-md-3 apt-logo" v-if= "!isLoadinglogo">
      <img class="c-avatar-img" v-if="partnerLogo ===''" src="img/logo_brand.png" alt="" />
      <img class="c-avatar-img" v-if="partnerLogo !==''" :src="getImage(partnerLogo)" alt="" />
      <!-- <img src="img/paypal-btn.png"> -->
    </div>
    <div class="col-md-6">
      <div class="ap-frm-tit-one">
        <h3>{{locationInfo.locationName}} <span v-if="locationInfo.description!==false">{{locationInfo.description}}</span></h3>
     
    </div>
  </div>
    <div class="col-md-3">
      <!-- <div class="edit-btn" onClick="edit">
      <button >Editor</button>

      </div> -->
      <CButton class="edit-btn"  @click="editmethod">Editor</CButton>
    </div>
  </div>
  <div class="col" v-if="edit">

  <div class="row">
  <div class="col" >
      <div class="full-btn">
      <CButton class="edit-btn"  @click="onEdit">Editor</CButton>
    </div>
  </div>
  </div>

    <div class="row pt-4">
    <div class="col-md-4 apt-logo">
     
    <img class="c-avatar-img" v-if="partnerLogo ===''" src="img/logo_brand.png" alt="" />
      <img class="c-avatar-img" v-if="partnerLogo !==''" :src="getImage(partnerLogo)" alt="" />
    
  </div>
  <div class="col-md-8">
    <div class="ap-frm-tit-one">
      <h3>{{locationInfo.locationName}} <span v-if="locationInfo.description!==false">{{locationInfo.description}}</span></h3>
    </div>
  </div>
  </div>
</div>

  <div class="row pt-4 map-frm">
    <div class="col-md-5">
      <div v-if="isLoadingLocation">
        <semipolar-spinner
                  :animation-duration="2000"
                  :size="80"
                  color="blue"></semipolar-spinner>
      </div>
      <div class="map" v-if="!isLoadingLocation">


      <iframe
        width="100%"
        height="550"
        style="border:0"
        loading="lazy"
        allowfullscreen
        :src="getplaceid(locationInfo.place_id)">
      </iframe>
    </div>
  </div>


    <div class="col-md-7" v-if="!edit">
      <div class="form-in">
        <div class="row">
            <!-- <input type="text" class="form-control" placeholder="Name" name=""> -->
            <div class="col-md-2"><Strong>Datos  </Strong></div>
            <div class="col-md-9" v-if="locationInfo.profile_description!==false">{{locationInfo.profile_description}}</div>
            
        </div>
        <div class="row ">
            <div class="col-md-2 pt-2"><Strong>Dirección </Strong></div>
            <div class="col-md-9 pt-2" v-if="locationInfo.address!==false">{{locationInfo.address}}<br/></div>
        </div>

        <div class="row ">
            
             <div class="col-md-2 "><Strong>&nbsp;&nbsp;&nbsp;</Strong></div>
            <div class="col-md-9 " v-if="locationInfo.city!==false">{{locationInfo.city}}<br/> </div>
             
            
        </div>
        <div class="row ">
            
              <div class="col-md-2 "><Strong>&nbsp;&nbsp;&nbsp;</Strong></div>
            <div class="col-md-9  " v-if="locationInfo.comunidad_autonoma!==false">{{locationInfo.comunidad_autonoma}}<br/> </div>

        </div>
        <div class="row ">
            
              <div class="col-md-2 "><Strong>&nbsp;&nbsp;&nbsp;</Strong></div>
            <div class="col-md-9  " v-if="locationInfo.zip_code!==false">{{locationInfo.zip_code}}<br/> </div>
              
            
        </div>
        <div class="row pt-4">
            <!-- <input type="text" class="form-control" placeholder="Pincode" name=""> -->
            <!-- <div class="col-md-1"><Strong>Horario</Strong></div> -->
            <!-- <div class="col-md-12" >

                <business-hours  
                :days="locationSchedule1" 
                :timeIncrement=30
                :switchWidth=75
                :hourFormat24=true></business-hours>
              </div> -->

             <div class="col-md-2"><Strong>Horario</Strong></div>

            <div class="col-md-9" >



              <!-- <div v-for="item in locationSchedule1" :key="item.id"> 
                <span v-if="current_day === item.open_day">
                  {{item.open}} - {{item.close}}</span>              
              
              </div> -->
              <div v-if="!show">
              <div v-for='(value,key) in locationSchedule1' :key='key'>
                <span v-if="current_day === key ">
                  <span class="uppercase">{{key}}</span> : <CBadge color="secondary float-right " @click="showAll" shape="pill" > <i size="4x" class="  cil-chevron-double-down "></i> </CBadge><span class="timealign" v-for="item in value"  >{{item.open_time}} - {{item.close_time}}</span> </span> 

              </div>
              </div>
              
              <div v-if="show">
                <CBadge color="secondary float-right " @click="showAll" shape="pill"><i size="4x" class="cil-chevron-double-up"></i></CBadge>
              <div v-for='(value,key) in locationSchedule1' :key='key'>
                
                  <span class="uppercase">{{key}}</span> : <span class="timealign" v-for="item in value"  >{{item.open_time}} - {{item.close_time}}</span> 

              </div>
              </div>
              
             
            
            <!-- <ul>
            <div v-for="item in locationSchedule1" :key="item.id">               
              <span v-if="current_day !== item.open_day">{{ item.open_day  }} Opens : {{item.open_time}} Close : {{item.close_time}}</span>
            </div>
            </ul> --> </div>
            

        </div>

        <div class="row pt-4">
            <!-- <input type="text" class="form-control" placeholder="State" name=""> -->
             <div class="col-md-2"><Strong>Category </Strong></div>
            <div class="col-md-9">{{locationPrimaryCategory.name}}<br/> </div>
            
          </div>
        </div>
      </div>
    
    <div class="col-md-7" v-if="edit">
      <div class="form-in">
        <div class="row">
          <div class="col-md-2  pt-2"><Strong>Datos </Strong></div>
          <div class="col-md-9"> 
            <textarea type="text" rows="4" class="form-control" placeholder="Datos" v-model="location_description" name="location_description" ></textarea>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-md-2  pt-2"><Strong>Dirección </Strong></div>
          <div class="col-md-9"> 
            <input type="text" class="form-control" placeholder="Address" v-model="address" name="address"  />
            <input type="text" class="form-control" placeholder="Locality" v-model="locality" name="locality" />
            <input type="text" class="form-control" placeholder="Administrative area" v-model="administrative_area" name="administrative_area" />
            <input type="text" class="form-control" placeholder="Region code" v-model="region_code" name="region_code" />
            <input type="text" class="form-control" placeholder="Postal code" v-model="postal_code" name="postal_code" />
          </div>
        </div>



        <!-- <div class="row pt-4">
                    <div class="col-md-1 pt-2"><Strong>Horario </Strong></div>

          <div class="col-md-12"> 
            
                <business-hours  
                :days="locationSchedule1" 
                :timeIncrement=30
                :switchWidth=75
                :hourFormat24=true ></business-hours>

          </div>
        </div> -->


        <div class="row pt-4">
                    <div class="col-md-2"><Strong>Horario </Strong></div>

          <div class="col-md-9"> 
            <div v-if="!show">
              <div v-for='(value,key) in locationSchedule1' :key='key'>
                <span v-if="current_day === key ">
                  <span class="uppercase">{{key}}</span> : <CBadge color="secondary float-right " @click="showAll" shape="pill" > <i size="4x" class="  cil-chevron-double-down "></i> </CBadge><span class="timealign" v-for="item in value"  >{{item.open_time}} - {{item.close_time}}</span> </span> 

              </div>
              </div>
              
              <div v-if="show">
                <CBadge color="secondary float-right " @click="showAll" shape="pill"><i size="4x" class="cil-chevron-double-up"></i></CBadge>
              <div v-for='(value,key) in locationSchedule1' :key='key'>
                
                  <span class="uppercase">{{key}}</span> : <span class="timealign" v-for="item in value"  >{{item.open_time}} - {{item.close_time}}</span> 

              </div>
              </div>
          </div>
        </div>

        <div class="row pt-4">
          <div class="col-md-2 pt-2"><Strong>Category </Strong></div>
          <div class="col-md-9"> 
            <!-- <input type="text" class="form-control" placeholder="Category" name="" /> -->
                    <multiselect
                    v-model="selected_categories"
                    placeholder="Seleccione un Category"
                    label="display_name"
                    track-by="id"
                    :options="possible_categories"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :multiple="false"
                    :taggable="false"
                    ></multiselect>
          </div>
        </div>
    </div>
  </div>
  </div>

  
  <div class="row pt-5">
  <div class="col-md-12 text-center">
    <div class="ap-url ">
                      <CLink
                        :href="locationInfo.websiteUrl"
                        target="_blank"
                      >{{locationInfo.websiteUrl}}</CLink>
     <!--  <a href="locationInfo.websiteUrl">{{locationInfo.websiteUrl}}</a> -->
    </div>
  </div>
</div>


  </div>


  </div>
</div>
<div class="row pt-5  text-center pb-20">
  <div class="col-md-8 m-auto text-center slide1"  >
    <transition-group name="fade1" >
      <div v-for="i in [currentIndex]" :key="i">
        <img :src="currentImg"  />
      </div>
    </transition-group>
     <a class="prev" @click="prev" href="javascript:void(0)" >&#10094; Prev</a>
    <a class="next" @click="next"  href="javascript:void(0)">&#10095; Next</a> 
</div>
</div>
<!--<div class="row pt-5  text-center pb-20"> -->
<!--<div class="col slider">
 <vue-image-slider :images="locationMedia"  :intervalVal=20000 :height=600 :width=900  /> 
</div>-->
<!-- <div class="col-md-8 m-auto text-center">
    <transition-group name="fade" tag="div">
      <div v-for="i in [currentIndex]" :key="i">
        <img :src="currentImg" height="400px"  />
      </div>
    </transition-group>
     <span class="prev" @click="prev" >&#10094;</span>
    <span class="next" @click="next"  >&#10095;</span> 
  </div>
-->

<!-- <div>
  <CCarousel
    arrows
    indicators
    animate
    height="450px"
  >
    <span v-for="item in locationMedia" :key="index">
    <CCarouselItem
      
      image="item"
      
    />
  </span>
  </CCarousel>
  </div> 
</div>-->
<div class="row pt-5 ap-frm-two">
  <div class="col">

  <!-- <div class="row">
    <div class="col">
      <div class="full-btn">
      <button>Editor</button>
    </div>
  </div>
  </div> -->

    <!-- <div class="row pt-4">
    <div class="col-md-4 apt-logo">
     
     <img src="img/paypal-btn.png">
    
  </div>
  <div class="col-md-8">
    <div class="ap-frm-tit-one">
      <h3>Madrid <span>Calle Fuencarre</span></h3>
    </div>
  </div>
  </div> -->

   <div class="row pt-4 map-frm">
    <div class="col-md-5">
      <div class="map">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d222388.83190311695!2d-95.03636780907286!3d29.433896187572614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x863f7912a0edb117%3A0x862d9cbcadeeb4e1!2sTexas%20City%2C%20TX%2C%20USA!5e0!3m2!1sen!2sin!4v1614955935293!5m2!1sen!2sin" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
    </div>
  </div>


  <div class="col-md-7">
    <div class="form-in">
    <div class="row">
      <div class="col-md-12"> 
        <input type="text" class="form-control" placeholder="Name" name="">
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-md-12"> 
        <input type="text" class="form-control" placeholder="Email" name="">
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-md-12"> 
        <input type="text" class="form-control" placeholder="Pincode" name="">
      </div>
    </div>

    <div class="row pt-4">
      <div class="col-md-12"> 
        <input type="text" class="form-control" placeholder="State" name="">
      </div>
    </div>
</div>
  </div>


  </div>


<div class="row pt-4 ap-slide">
  <div class="col">
  <div id="demo" class="carousel slide" data-ride="carousel">
  <ul class="carousel-indicators">
    <li data-target="#demo" data-slide-to="0" class="active"></li>
    <li data-target="#demo" data-slide-to="1"></li>
    <li data-target="#demo" data-slide-to="2"></li>
  </ul>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="img/slide1.jpg" alt="Los Angeles" height="300px" >
      <div class="carousel-caption">
      </div>   
    </div>
    <div class="carousel-item">
      <img src="img/slide1.jpg" alt="Chicago" height="300px">
      <div class="carousel-caption">
      </div>   
    </div>
    <div class="carousel-item">
      <img src="img/slide1.jpg" alt="New York"  height="300px">
      <div class="carousel-caption">
      </div>   
    </div>
  </div>
  <a class="carousel-control-prev" href="#demo" data-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </a>
  <a class="carousel-control-next" href="#demo" data-slide="next">
    <span class="carousel-control-next-icon"></span>
  </a>
</div>
</div>
</div>


</div>
</div>




  </div>
  </div>
</template>

<script>
import { getStyle, hexToRgba } from "@coreui/utils/src";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";
import store from "../../store";
import moment from "moment";
import VueImageSlider from 'vue-image-slider'
import Multiselect from "vue-multiselect";
import { 
   mdbIcon, 
} from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import { Slider } from "./Slider.vue";

const items = [
];

export default {
  name: "LocationDetail",
  props: ["itemID","location"],
  computed: {
    
  },
  components: {
    DatePicker,
    VueImageSlider,
    Multiselect,
    mdbIcon,
    Slider,
    SemipolarSpinner
  },
   
  data() {
    return {
      isLoading:true,
      location_id:Number(this.$route.params.itemID),
      locationInfo:[],
      locationSchedule:[],
      locationSchedule1:{},
      locationMedia:[],
      partnerLogo:"",
      locationPrimaryCategory:[],
      isLoadingLocation:false,
      isLoadingSchedule:false,
      isLoadingMedia:false,
      isLoadinglogo:false,
      isLoadingCategory:[],
      edit:false,
      address:"",
      locality:"",
      administrative_area:"",
      location_description:"",
      region_code:"",
      postal_code:"",
      selected_categories:{},
      possible_categories:[],
      today : moment().utc().format('dddd'),
      current_day:"",
      show:false,
      images: [],
      timer: null,
      currentIndex: 0,
      partner_id:"",

    };
  },
  async mounted() {
      // this.check();
      var today1 = this.today;
      this.current_day=today1.toLowerCase();
      //console.log("current_day ", this.current_day);
      let location_id=Number(this.$route.params.itemID);
      let partner_id=Number(this.$route.query.partner);
      if(partner_id !=="" && partner_id !== undefined){
        this.partner_id=Number(this.$route.query.partner);
        await this.getPartnerLogo();
      }
      if(location_id!=="" ||location_id!==undefined ){
        //console.log("itemID",Number(this.$route.params.itemID));
        this.location_id=Number(this.$route.params.itemID);
        
        //console.log("partner_id ::: ",this.$route.query.partner);

        await this.getLocationInfo();
        await this.getLocationPrimaryCategory();
        await this.getpossibleCategories();
        await this.getLocationSchedule();
        await this.getLocationMedia();
        this.startSlide();

      }
  },
   computed: {
    currentImg: function() {
      return this.images[Math.abs(this.currentIndex) % this.images.length];
    }
  },
  methods: {
    editmethod() {
      //console.log("in check");
      this.edit=!this.edit;

    },
    showAll(){
      this.show = !this.show;
    },

    getImage(pic){

          return "data:image/png;base64,"+pic
    },
    getplaceid(item){
      //console.log("=============titem :::: ", item);
      return "https://www.google.com/maps/embed/v1/place?key=AIzaSyBmeCWum59AO-zfAD54tea8Viznq3aqeTY&q=place_id:"+item
    },
    async getLocationInfo(){
      var location_info=[];
      this.isLoadingLocation = true;
      var location_id=Number(this.$route.params.itemID);
      var payload ={
        location_id: location_id
      }
      await store.dispatch("getLocationInfo", payload).then(() => {
        location_info = store.getters.getLocationInfo;
        if(location_info.length>0)
          this.locationInfo = location_info[0];
          this.address = this.locationInfo.address;
          this.location_description = this.locationInfo.profile_description;
          this.administrative_area = this.locationInfo.comunidad_autonoma;
          this.postal_code = this.locationInfo.zip_code;
          this.locality = this.locationInfo.city;
          this.region_code = this.locationInfo.regionCode;

          // locality
          //     administrative_area
          //     region_code
          //     postal_code

          //     city
          //    comunidad_autonoma
          //    zip_code
        
        return;
      });
      this.isLoadingLocation = false;

    },
    clean(t){
      var temp=""
      if(t!="" || t!=undefined)
        temp = t.replace(":", "");
      return temp
    },
    async getLocationSchedule(){
      var location_schedule=[];
      this.isLoadingSchedule = true;
      var location_id=Number(this.$route.params.itemID);
      var payload ={
        location_id: location_id
      }
      await store.dispatch("getLocationSchedule", payload).then(() => {
        location_schedule = store.getters.getLocationSchedule;
        this.locationSchedule=location_schedule;
        var schedule_days={};
          if(location_schedule.length>0){
            var prev_key="";

            var day=[];
            location_schedule.forEach((loc)=>{
            var day2=[];

              var key = loc.open_day.toLowerCase();
              // console.log(prev_key ,key, "=========prev_key !== key")
              if (prev_key !== key) {
                day=[];
                day.push({
                  open:this.clean(loc.open_time),
                  close:this.clean(loc.close_time),
                  open_time:loc.open_time,
                  close_time:loc.close_time,
                  id:loc.id,
                  isOpen:true
                })
                // schedule_days[key]=day1;
                prev_key = key;
                // schedule_days[key]=day;
              }else{
                day.push({
                  open:this.clean(loc.open_time),
                  close:this.clean(loc.close_time),
                  open_time:loc.open_time,
                  close_time:loc.close_time,
                  id:loc.id,
                  isOpen:true
                });
              }
              //console.log("day ::: ", day);
              
              schedule_days[key]=day;

            })
            //console.log("schedule_days", schedule_days)
            this.locationSchedule1 = schedule_days;
          }
        return;
      });
      this.isLoadingSchedule = false;

    },
    async getLocationMedia(){
      var location_media=[];
      this.isLoadingMedia = true;
      var location_id=Number(this.$route.params.itemID);
      var payload ={
        location_id: location_id
      }
      await store.dispatch("getLocationMedia", payload).then(() => {
        location_media = store.getters.getLocationMedia;
        if(location_media.length>0)
          {
            // this.locationMedia = location_media;
            var images=[];
            location_media.forEach((media)=>{
              images.push(media.media_url);
            });
            this.locationMedia = images;
            this.images = images;
          }
        
        return;
      });
      this.isLoadingMedia = false;
    },

    async getPartnerLogo(){
      var location_logo="";
      this.isLoadinglogo = true;
      var location_id=Number(this.partner_id);//Number(this.$route.params.itemID);
      var payload ={
        location_id: location_id
      }
      await store.dispatch("getPartnerLogo", payload).then(() => {
        location_logo = store.getters.getPartnerLogo;
        if(location_logo.length>0)
          {
            // this.locationMedia = location_media;
            
            this.partnerLogo = location_logo[0].image_1920;
          }
        
        return;
      });
      this.isLoadinglogo = false;
    },

    async getLocationPrimaryCategory(){
      var location_primarycat=[];
      this.isLoadingCategory = true;
      var location_id=Number(this.$route.params.itemID);
      var payload ={
        location_id: location_id
      }
      await store.dispatch("getLocationPrimaryCategory", payload).then(() => {
        location_primarycat = store.getters.getLocationPrimaryCategory;
        //console.log("location_primarycat :: ", location_primarycat);
        if(location_primarycat.length>0)
          this.locationPrimaryCategory = location_primarycat[0];
        // location_primarycat.forEach((cat)=>{
        //   if(cat.id === )
        // })
        //console.log("this.locationPrimaryCategory :::: ", this.locationPrimaryCategory);
        this.selected_categories = {id:this.locationPrimaryCategory.id,category_id:this.locationPrimaryCategory.category_id, display_name:this.locationPrimaryCategory.name}; //this.locationPrimaryCategory;//
        
        return;
      });
      this.isLoadingCategory = false;
    },
    /* Get possibleCategories*/
    async getpossibleCategories(){
      //console.log("==========> test update direction");
      var category_id ="";
      var payload ={
         category_id:category_id
      }
      //console.log("payload", payload);
      var possible_categories =[];
      await store.dispatch("getpossibleCategories",payload).then(() => {
            possible_categories = store.getters.getpossibleCategories;
            //console.log("store possible_categories", possible_categories);
            this.possible_categories = possible_categories;
            if(possible_categories.length > 0){
              possible_categories.forEach((cat)=>{
                if(this.locationPrimaryCategory.category_id === cat.category_id){
                  this.selected_categories = {id:cat.id,category_id:cat.category_id, display_name:cat.name} 
                }
              })
               
            }
            
            // this.modalAnadiratributo=false;
          })
          return;
       
    },
    /* Set possibleCategories*/
    async setLocationCategories(e){
      //console.log("==========> test update direction", this.selected_categories);
      var payload ={
        "location_field": "add_category",
        "primary_category":true,
        "category_list": [{"category_name":this.selected_categories.display_name,"category_id":this.selected_categories.id}],
        row_data: Number(this.$route.params.itemID)
        
      }
      //console.log("payload", payload);
      await store.dispatch("setLocationCategories",payload).then(() => {
            var category_updated = store.getters.setLocationCategories;
            //console.log("store nombre update", category_updated);
            this.getlocation();
            this.modalCategoriaprincipal=false;
          })
          return;
       
    },
    async setlocCategory(){
      //console.log("==========> test update direction", this.selected_categories);
      var payload ={
        "location_field": "add_category",
        "primary_category":true,
        "category_list": [{"category_name":this.selected_categories.display_name,"category_id":this.selected_categories.category_id}],
        row_data: Number(this.$route.params.itemID)
        
      }
      //console.log("payload", payload);
      await store.dispatch("setlocCategory",payload).then(() => {
            var category_updated = store.getters.setlocCategory;
            //console.log("store nombre update", category_updated);
            // this.getlocation();
            // this.modalCategoriaprincipal=false;
          })
          return;
       
    },
    async updateDirection(e){
      // console.log("==========> test update direction", this.row_data);
      var payload ={
        location_field:"change_address",
        "postal_code": this.postal_code,
        "region_code": this.region_code,
        "administrative_area":this.administrative_area,
        "locality":this.locality,
        "address":this.address,
        row_data:Number(this.$route.params.itemID)
        
      }
      //console.log("payload", payload);
      await store.dispatch("updateDirection",payload).then(() => {
            var nombre = store.getters.updateDirection;
            //console.log("store nombre update", nombre);
            // this.getlocation();
            // this.modalDirection=false;
          })
          return;
       
    },
    async setlocationDescription(){
      // console.log("==========> test update direction", this.selected_categories);
      var payload ={
        "location_field": "change_description",
        "profile_description":this.location_description,
         row_data:Number(this.$route.params.itemID)
      }
      //console.log("payload", payload);
      await store.dispatch("setlocationDescription",payload).then(() => {
            var description_updated = store.getters.setlocationDescription;
            //console.log("store nombre update", description_updated);
            // this.getlocation();
            // this.modalDescripcion=false;
          })
          return;
       
    },
    async onEdit(){
      //console.log("address", this.address);
      //console.log("locality", this.locality);
      //console.log("administrative_area", this.administrative_area);
      //console.log("region_code", this.region_code);
      //console.log("postal_code", this.postal_code);
      this.setlocationDescription();
      this.updateDirection();
      // this.setLocationCategories();
      this.setlocCategory();
      await this.getLocationInfo();
        await this.getLocationPrimaryCategory();
        await this.getpossibleCategories();
        
      this.editmethod();

    },
    startSlide: function() {
      this.timer = setInterval(this.next, 10000);
    },

    next: function() {
      this.currentIndex += 1;
      
    },
    prev: function() {
      this.currentIndex -= 1;
      
    }


  },
};
</script>
<style scoped>
.active {
  background-color: lightgray;
}
.inactive {
  background-color: white;
}

.ap-frm-one button{ width: 100%; background: #333;  box-shadow: #33333347 0 0 4px 2px; border-radius: 30px;  color: #fff; cursor: pointer; padding:15px 0px; height:70px;
  display: block;  text-transform: uppercase;font-size: 16px;
}
.ap-frm-one .ap-frm-tit-one h3{background: #f9f9f9; border-radius: 50px; font-size: 18px; font-weight: 600;   text-align: center; line-height: 24px; padding:15px 0px; height:70px; text-transform: uppercase;}
.ap-frm-one .ap-frm-tit-one h3 span {font-size: 14px; display: block; text-transform: initial}
.ap-frm-one button:focus {font-size: 16px; outline: none; display: block; text-transform: uppercase}
.apt-logo img{ width: 60px; align-items: "center" }
.ap-frm-two { display: none; padding-bottom: 40px;}
.ap-frm-two .ap-frm-tit-one h3{ background: #f1f1f1; border-radius: 50px; font-size: 18px; font-weight: 600;  padding-top: 10px; text-align: center; line-height: 24px; }
.ap-frm-two .ap-frm-tit-one h3 span {font-size: 14px; display: block;}
.ap-frm-two button {width: 100%; background: #162967; border: none;
  border-radius: 30px;  padding: 10px 0;  color: #fff;
  box-shadow: #1629672b 0 0 4px 2px;}
.ap-frm-two button:focus {outline: none;}
.map-frm .form-control { background: none; border:none; border-bottom: 1px solid #b3b3b3; border-radius: 0; }
.map-frm .form-in {
  background: #ffffff;
  width: 100%;
  padding: 40px 20px;
  border-radius: 20px;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 7%), 0 3px 1px -2px rgb(0 0 0 / 0%), 0 1px 5px 0 rgb(0 0 0 / 8%);


}
.form-in strong {display: block; text-transform: uppercase;}
.map-frm .form-control:focus {outline: none; box-shadow: none;}
.ap-frm-two .ap-frm-tit { text-align: center; }
.carousel-inner img {
  width: 100%;
  height: 100%;
}
.carousel-item {height: 300px;}
.carousel-inner img {height: auto;}
.ap-url { width: 100%; background: #f9f9f9; border-radius: 40px; }
.ap-url a{width: 100%; font-size: 14px; padding: 10px 10px; display: block; }
.uppercase {
  text-transform: uppercase; font-weight: bold;
}
.timealign {
  display: block; padding: 1px 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width:100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width:100%;
  opacity: 0;
}

/*img {
  height:600px;
  width:100%
}*/
.slide1{
  position: relative;
}
.slide1 .prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.7s ease;
  border-radius: 0 4px 4px 0;
  text-decoration: none;
  user-select: none;
}

.next {
  right: 0;
}

.prev {
  left: 0;
}

.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.9);
}
/*.slider_apache{
  width: 70%;
  margin: 0 auto;
  display: block;
}*/

</style>
<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style> -->
